<template>
  <transition name="scroll-btn-fade">
    <button
      v-show="visible"
      class="scroll-to-top-btn"
      :aria-label="t('general.scroll_top', 'Volver arriba')"
      @click="scrollToTop"
    >
      <v-icon size="20">
        mdi-chevron-up
      </v-icon>
    </button>
  </transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const visible = ref(false);

function getScrollContainer() {
  return document.querySelector(".main-container") || null;
}

function onScroll() {
  const container = getScrollContainer();
  const scrolled = container ? container.scrollTop : window.scrollY;
  visible.value = scrolled > 400;
}

function scrollToTop() {
  const container = getScrollContainer();
  if (container && container.scrollTop > 0) {
    container.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

onMounted(() => {
  window.addEventListener("scroll", onScroll, { passive: true });
  const container = getScrollContainer();
  if (container) container.addEventListener("scroll", onScroll, { passive: true });
});

onUnmounted(() => {
  window.removeEventListener("scroll", onScroll);
  const container = getScrollContainer();
  if (container) container.removeEventListener("scroll", onScroll);
});
</script>

<style scoped>
.scroll-to-top-btn {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  transition: all 0.2s ease;
}

.scroll-to-top-btn:hover {
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: #1e293b;
  transform: translateY(-2px);
}

.scroll-to-top-btn:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.scroll-btn-fade-enter-active,
.scroll-btn-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.scroll-btn-fade-enter-from,
.scroll-btn-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

@media (max-width: 600px) {
  .scroll-to-top-btn {
    bottom: 80px;
    right: 16px;
    width: 44px;
    height: 44px;
  }
}
</style>
